import { render } from "./TeamPerformance.vue?vue&type=template&id=1024d01e&scoped=true"
import script from "./TeamPerformance.vue?vue&type=script&lang=js"
export * from "./TeamPerformance.vue?vue&type=script&lang=js"

import "./TeamPerformance.vue?vue&type=style&index=0&id=1024d01e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1024d01e"

export default script